export default __webpack_public_path__ + "d7c4a4b0cf6e279d005f01eca4a6c365.svg";